/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, ref, watch } from '@vue/composition-api';
import props from '../props.js';
import '../const.js';
import { RadioGroup, RadioButton } from '../../radio/index.js';
import { useBaseClassName } from '../hooks.js';
import { COLOR_MODES } from '../../_common/js/color-picker/constants.js';
import '../../radio/radio.js';
import '../../_chunks/dep-1461d230.js';
import 'vue';
import '../../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/camelCase';
import '../../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/kebabCase';
import '../../radio/props.js';
import '../../utils/event.js';
import '../../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../utils/mixins.js';
import '../../radio/group.js';
import 'lodash/isString';
import 'lodash/isNumber';
import '../../radio/radio-group-props.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../radio/radio-button.js';
import '../../utils/map-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../radio/type.js';
import '../../hooks/useConfig.js';
import '../../config-provider/useConfig.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PanelHeader = defineComponent({
  name: "PanelHeader",
  components: {
    TRadioGroup: RadioGroup,
    TRadioButton: RadioButton
  },
  props: _objectSpread(_objectSpread({}, props), {}, {
    mode: {
      type: String,
      "default": "color"
    },
    togglePopup: {
      type: Function
    },
    handleModeChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props2) {
    var baseClassName = useBaseClassName();
    var modeValue = ref(props2.mode);
    watch(function () {
      return props2.mode;
    }, function (v) {
      modeValue.value = v;
    });
    return {
      baseClassName: baseClassName,
      modeValue: modeValue
    };
  },
  render: function render() {
    var _this$colorModes,
      _this$colorModes2,
      _this = this;
    var h = arguments[0];
    if (((_this$colorModes = this.colorModes) === null || _this$colorModes === void 0 ? void 0 : _this$colorModes.length) === 1) {
      return null;
    }
    var baseClassName = this.baseClassName;
    return h("div", {
      "class": "".concat(baseClassName, "__head")
    }, [h("div", {
      "class": "".concat(baseClassName, "__mode")
    }, [((_this$colorModes2 = this.colorModes) === null || _this$colorModes2 === void 0 ? void 0 : _this$colorModes2.length) === 1 ? COLOR_MODES[this.colorModes[0]] : h("t-radio-group", {
      "attrs": {
        "variant": "default-filled",
        "size": "small",
        "disabled": this.disabled
      },
      "on": {
        "change": this.handleModeChange
      },
      "model": {
        value: _this.modeValue,
        callback: function callback($$v) {
          _this.modeValue = $$v;
        }
      }
    }, [Object.keys(COLOR_MODES).map(function (key) {
      return h("t-radio-button", {
        "key": key,
        "attrs": {
          "value": key
        }
      }, [COLOR_MODES[key]]);
    })])])]);
  }
});

export { PanelHeader as default };
//# sourceMappingURL=header.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/color-picker/panel/header.js
// module id = null
// module chunks = 